import { render, staticRenderFns } from "./nonProjectIssues.vue?vue&type=template&id=2c333d0c&scoped=true"
import script from "./nonProjectIssues.vue?vue&type=script&lang=js"
export * from "./nonProjectIssues.vue?vue&type=script&lang=js"
import style0 from "./nonProjectIssues.vue?vue&type=style&index=0&id=2c333d0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c333d0c",
  null
  
)

export default component.exports